import { createTDIn, setElementInnerHTML, setElementOnClick } from '../../ui_utils/DomUtils.ts';
import { UILobbyTableRowPlayersController } from './UILobbyTableRowPlayersController.ts';
import { MapDataController } from '../../../../../shared/map_data/MapDataController.ts';
import { GameModeDataController } from '@colonist/shared-types';
import { ModeSettingEnum, PlayerEnums } from '../../../../../shared/GameEnums.ts';
import { logError } from '../../ui_utils/Utils.ts';
import { UILobbyTableRowNoTrollsController } from './UILobbyTableRowNoTrollsController.ts';
import { getDefaultMapForGameMode } from '@colonist/types';
export class UILobbyTableRowController {
    createRowElement() {
        const row = document.createElement('tr');
        row.classList.add('transitioning');
        setTimeout(()=>{
            row.classList.remove('transitioning');
        }, this.TRANSITION_TIME_MS);
        return row;
    }
    update(roomData) {
        var _GameModeDataController_getModeDataForMode, _MapDataController_getMapDataForMap;
        this.players.update(roomData.players, roomData.maxPlayers, this.roomData);
        this.noTrollsIcon.update(roomData.minimumKarma, this.roomData);
        const newMode = roomData.modePlayable ? roomData.gameModeSetting : ModeSettingEnum.Classic4P;
        const newModeSetting = (_GameModeDataController_getModeDataForMode = GameModeDataController.getModeDataForMode(newMode)) === null || _GameModeDataController_getModeDataForMode === void 0 ? void 0 : _GameModeDataController_getModeDataForMode.name;
        const newModeSettingText = newModeSetting !== null && newModeSetting !== void 0 ? newModeSetting : {
            key: 'strings:colonistCommon.utils.emptyString'
        };
        const newMapSetting = (_MapDataController_getMapDataForMap = MapDataController.getMapDataForMap(roomData.mapPlayable ? roomData.gameMapSetting : getDefaultMapForGameMode(newMode))) === null || _MapDataController_getMapDataForMap === void 0 ? void 0 : _MapDataController_getMapDataForMap.name;
        const newMapSettingText = newMapSetting !== null && newMapSetting !== void 0 ? newMapSetting : {
            key: 'strings:colonistCommon.utils.emptyString'
        };
        if (newMapSetting == undefined || newModeSetting == undefined) {
            logError('update', [
                'Error no such mode ' + roomData.gameModeSetting
            ]);
            logError('update', [
                'Error no such map ' + roomData.gameMapSetting
            ]);
            return;
        }
        setElementInnerHTML(this.tdMode, newModeSettingText);
        setElementInnerHTML(this.tdMap, newMapSettingText);
        setElementInnerHTML(this.tdSpeed, PlayerEnums.getSpeedSettingText(roomData.speed));
        this.roomData = roomData;
    }
    remove() {
        this.tableRow.classList.add('transitioning');
        setTimeout(()=>{
            if (!this.tableRow.parentElement) return;
            this.tableRow.parentElement.removeChild(this.tableRow);
        }, this.TRANSITION_TIME_MS);
    }
    getId() {
        return this.roomData.id;
    }
    setRoomAvailable(userKarma, unavailable) {
        const isUnavailable = unavailable || userKarma !== undefined && userKarma < this.roomData.minimumKarma;
        this.tableRow.classList.toggle('lobby_table_row_unavailable', isUnavailable !== null && isUnavailable !== void 0 ? isUnavailable : false);
    }
    constructor(container, roomData, buttonAction){
        this.TRANSITION_TIME_MS = 300;
        this.tableRow = this.createRowElement();
        container.appendChild(this.tableRow);
        this.tdMode = createTDIn(this.tableRow);
        this.tdMap = createTDIn(this.tableRow);
        this.tdSpeed = createTDIn(this.tableRow);
        const tdNoTrolls = createTDIn(this.tableRow, 'lobby_table_data_no_trolls');
        const tdPlayers = createTDIn(this.tableRow, 'lobby_table_data_players');
        this.noTrollsIcon = new UILobbyTableRowNoTrollsController(tdNoTrolls, roomData);
        this.players = new UILobbyTableRowPlayersController(tdPlayers, roomData);
        this.roomData = roomData;
        setElementOnClick(this.tableRow, ()=>buttonAction(roomData.id));
    }
}
